import React, { useState } from "react";
import { Box, Button, Container, Typography, Paper } from "@mui/material";
import { Add } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import AddTeamMemberModal from "./AddTeamMemberModal";
import TeamMembersTable from "./TeamMembersTable";
import AdminSideNav from "../../../adminComponents/sidenav";
import AdminHeader from "../../../adminComponents/header";

const TeamMember = () => {
  const { id } = useParams(); // Get client ID from URL params
  const [openModal, setOpenModal] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSuccess = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          ml: { xs: "0px", md: "200px" },
        }}
      >
        {/* <AdminSideNav /> */}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
          }}
        >
          <Container maxWidth="xl" sx={{ py: 4 }}>
            <Paper sx={{ p: 3, mb: 3 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography variant="body1" fontWeight={600} gutterBottom>
                    Team Member Management
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Manage team members for client ID: {id}
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  onClick={handleOpenModal}
                  sx={{
                    backgroundColor: "#4a90e2",
                    "&:hover": {
                      backgroundColor: "#357abd",
                    },
                  }}
                >
                  Add Team Member
                </Button>
              </Box>
            </Paper>

            {/* Team Members Table */}
            <TeamMembersTable clientId={id} refreshTrigger={refreshTrigger} />

            {/* Add Team Member Modal */}
            <AddTeamMemberModal
              open={openModal}
              onClose={handleCloseModal}
              clientId={id}
              onSuccess={handleSuccess}
            />
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default TeamMember;
